module.exports = __webpack_public_path__ + "static/img/activity2.ad65f44c.png";